(ns frontend.components.inputs.checkbox
  (:require
   [common.localization :as loc]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [frontend.utils]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [:value :placeholder :class-name
                :checkbox-text
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled?]}
        args
        edit-value (if (boolean? value) value false)]
    [:label.zap-inlined-checkbox-label
     [:input
      (merge {:ref         (fn [e]
                             (when (and e
                                        (not= e (:input-dom-node @dom-atom)))
                               (swap! dom-atom assoc :input-dom-node e)))
              :type        "checkbox"
              :checked     edit-value
              :class-name  (fu/cs "component-checkbox" (when has-focus? "focus") class-name)
              :on-focus    on-focus!
              :on-blur     (fn [e]
                             (let [checked? (-> e
                                                .-target
                                                .-checked)]
                               (when on-blur!
                                 (on-blur! e checked?))))
              :on-key-down on-key-down!
              :on-change   (fn [e]
                             (let [checked? (-> e
                                                .-target
                                                .-checked)]
                               (when on-change!
                                 (on-change! e checked?))
                               (when on-blur!
                                 (on-blur! e checked?))))}
             (when disabled?
               {:disabled (boolean disabled?)}))]
     [:span.checkmark]
     [:span.checkbox-label checkbox-text]]))

(defmethod editor :editor.type/checkbox
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Checkbox"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))


(defmethod display-string :editor.type/checkbox
  [args]
  (if (:value args)
    (loc/tr :yes)
    (loc/tr :no)))

(defmethod viewer :editor.type/checkbox
  [args]
  (r/create-class
   {:display-name   "Checkbox/viewer"
    :reagent-render (fn [args]
                      [:div.preview.preview-checkbox
                       (display-string args)])}))
